const toIntlDigits = (raw) => {
  const digits = String(raw || '').replace(/\D/g, '');
  if (!digits) return '';
  return digits.startsWith('0') ? `212${digits.slice(1)}` : digits;
};

const isPlaceholderDigits = (intl) => {
  const national = String(intl || '').replace(/^212/, '');
  return !national || national === '600000000' || /^0+$/.test(national);
};

export const isPlaceholderPhone = (raw) => isPlaceholderDigits(toIntlDigits(raw));

export const usableContact = (raw) => {
  const value = String(raw || '').trim();
  if (!value || isPlaceholderPhone(value)) return '';
  return value;
};

export const whatsappHref = (raw) => {
  const value = usableContact(raw);
  const intl = toIntlDigits(value);
  return intl ? `https://wa.me/${intl}` : null;
};

export const whatsappHrefWithText = (raw, text) => {
  const value = usableContact(raw);
  const intl = toIntlDigits(value);
  if (!intl) return null;
  const params = new URLSearchParams({ phone: intl, text: String(text || '') });
  return `https://api.whatsapp.com/send?${params.toString()}`;
};

export const formatPhoneDisplay = (raw) => {
  const value = usableContact(raw);
  const intl = toIntlDigits(value);
  if (!intl) return '';
  if (intl.startsWith('212') && intl.length === 12) {
    const local = intl.slice(3);
    return `+212 ${local.slice(0, 1)} ${local.slice(1, 3)} ${local.slice(3, 5)} ${local.slice(5, 7)} ${local.slice(7)}`;
  }
  return `+${intl}`;
};

export const telHref = (raw) => {
  const value = usableContact(raw);
  return value ? `tel:${value.replace(/\s/g, '')}` : null;
};

export const mailHref = (raw) => {
  const value = String(raw || '').trim();
  return value ? `mailto:${value}` : null;
};
